import { z } from 'zod';
// Formato cru de PushSubscription.toJSON() do browser.
export const pushSubscriptionSchema = z.object({
    endpoint: z.string().url(),
    expirationTime: z.number().nullable().optional(),
    keys: z.object({
        p256dh: z.string().min(1),
        auth: z.string().min(1),
    }),
    userAgent: z.string().max(255).optional(),
});
//# sourceMappingURL=push.js.map